import { createRouter, createWebHistory } from 'vue-router'
import auth from '@/services/auth'
import { resolveClientLandingPage, isForbiddenComplianceLanding } from '@/utils/landingPage'
import { clientOrgSetupOrgId } from '@/utils/orgSetupAccess'
import { isConferenceMode, isConferenceRoute } from '@/services/conferenceMode'
const Home = () => import('@/components/Home.vue')
const ClientDetail = () => import('@/views/ClientDetail.vue')
const ClientsList = () => import('@/components/ClientsList.vue')
const ClientWorkflowSettings = () => import('@/components/ClientWorkflowSettings.vue')
const WorkflowFromDocument = () => import('@/views/WorkflowFromDocPage.vue')
import Login from '@/views/Login.vue'
const ForgotPassword = () => import('@/views/ForgotPassword.vue')
const ResetPassword = () => import('@/views/ResetPassword.vue')
const ChangePassword = () => import('@/views/ChangePassword.vue')

const Logout = () => import('@/views/Logout.vue')
const Projects = () => import('@/components/ProjectsList.vue')
const ADIDashboard = () => import('@/views/ADIDashboard.vue')
const AIQDashboard = () => import('@/views/AIQDashboard.vue')
const ProgramCatalog = () => import('@/views/ProgramCatalog.vue')
const ADIWorkbench = () => import('@/views/ADIWorkbench.vue')
const ProjectDocuments = () => import('@/components/ProjectDocuments.vue')
const ComprehensiveAnalysisDashboard = () => import('@/components/comprehensive/ComprehensiveAnalysisDashboard.vue')
const ComplianceDashboard = () => import('@/views/ComplianceDashboard.vue')
const Settings = () => import('@/components/Settings.vue')
const PollieOrgProfileView = () => import('@/views/PollieOrgProfileView.vue')
const AnalysisRequestQueue = () => import('@/views/RequestsView.vue')
const ComprehensiveAnalysis = () => import('@/components/comprehensive/ComprehensiveAnalysis.vue')
const ActionsManager = () => import('@/components/ActionsManager.vue')
const AutomatedChecksManager = () => import('@/components/AutomatedChecksManager.vue')
const ComprehensiveCheckDefinitionEditor = () => import('@/views/ComprehensiveCheckDefinitionEditor.vue')
const RAGAnalyticsDemo = () => import('@/views/RAGAnalyticsDemo.vue')
const RAGAdminDashboard = () => import('@/views/RAGAdminDashboard.vue')
const RiskIndicatorLibrary = () => import('@/views/RiskIndicatorLibrary.vue')
const StatusChangesReport = () => import('@/components/StatusChangeManager.vue')
const PromptEnhancement = () => import('@/components/PromptEnhancementManager.vue')
const DSPyTestPage = () => import('@/views/DSPyTestPage.vue')
const ProjectSettings = () => import('@/views/ProjectSettings.vue')
const RAGAnalysis = () => import('@/views/RAGAnalysis.vue')
const UserManagement = () => import('@/views/UserManagement.vue')
const OrganizationSettings = () => import('@/views/OrganizationSettings.vue')
const OrganizationSetupWizard = () => import('@/views/OrganizationSetupWizard.vue')
const ComplianceOnboardingWizard = () => import('@/views/ComplianceOnboardingWizard.vue')
const HealthcareOnboardingWizard = () => import('@/views/HealthcareOnboardingWizard.vue')
const PatientIntakeWizard = () => import('@/views/PatientIntakeWizard.vue')
const OnboardingWizard = () => import('@/views/OnboardingWizard.vue')
const DisEnrollmentRiskDashboard = () => import('@/views/DisEnrollmentRiskDashboard.vue')
const CoverageRiskDashboard = () => import('@/views/CoverageRiskDashboard.vue')
const PlanCoverageQuery = () => import('@/views/PlanCoverageQuery.vue')
const ECPDataImport = () => import('@/views/ECPDataImport.vue')
const ClientManagementDashboard = () => import('@/views/ClientManagementDashboard.vue')
const BillingSettings = () => import('@/views/BillingSettings.vue')
const ConnectOnboarding = () => import('@/views/ConnectOnboarding.vue')
// 485 Client Upload Portal
const Upload485Landing = () => import('@/views/Upload485Landing.vue')
// Roster Upload Portal
const RosterUploadLanding = () => import('@/views/RosterUploadLanding.vue')
// Engagement Upload Portal
const EngagementUploadLanding = () => import('@/views/EngagementUploadLanding.vue')
// Secure Upload Multi-Step Views
const SecureUploadLanding = () => import('@/views/SecureUploadLanding.vue')
const SecureUploadAnalysis = () => import('@/views/SecureUploadAnalysis.vue')
const SecureUploadResults = () => import('@/views/SecureUploadResults.vue')
const SecureUploadFeedback = () => import('@/views/SecureUploadFeedback.vue')
const SecureUploadComplete = () => import('@/views/SecureUploadComplete.vue')
const ABTestingDashboard = () => import('@/views/ABTestingDashboard.vue')
const ComplianceHealthDashboard = () => import('@/views/ComplianceHealthDashboard.vue')
const RequirementLab = () => import('@/views/RequirementLab.vue')
const Extract485View = () => import('@/views/Extract485View.vue')
const InsuranceCoverageView = () => import('@/views/InsuranceCoverageView.vue')
const DatabaseConnections = () => import('@/views/DatabaseConnections.vue')
const DuplicateDetection = () => import('@/views/DuplicateDetection.vue')
const APIIntegrations = () => import('@/views/APIIntegrations.vue')
const DataSourceMonitor = () => import('@/views/DataSourceMonitor.vue')
const PolicyEngine = () => import('@/views/PolicyEngine.vue')
const ConvergingSignals = () => import('@/views/ConvergingSignals.vue')
const ConvergingSignalsReport = () => import('@/views/ConvergingSignalsReport.vue')
const ConvergingSignalsReportPrint = () => import('@/views/ConvergingSignalsReportPrint.vue')
const ConvergingSignalsPrint = () => import('@/views/ConvergingSignalsPrint.vue')
const IQHubPrint = () => import('@/views/IQHubPrint.vue')
const IQHubView = () => import('@/views/IQHubView.vue')
const ProviderStatusView = () => import('@/views/ProviderStatusView.vue')
const SignalFeedback = () => import('@/views/SignalFeedback.vue')
const StateIQView = () => import('@/views/StateIQView.vue')
const StateIQPrint = () => import('@/views/StateIQPrint.vue')
const MarketIntelligenceView = () => import('@/views/MarketIntelligenceView.vue')
const DocketIQView = () => import('@/views/DocketIQView.vue')
const ScenarioPlannerView = () => import('@/views/ScenarioPlannerView.vue')
const ScenarioPlannerListView = () => import('@/views/ScenarioPlannerListView.vue')
const ScenarioPlannerPrint = () => import('@/views/ScenarioPlannerPrint.vue')
const PolliePacketsView = () => import('@/views/PolliePacketsView.vue')
const PolliePacketPrint = () => import('@/views/PolliePacketPrint.vue')
const SourceCatalog = () => import('@/views/SourceCatalog.vue')
const BriefingEditor = () => import('@/views/BriefingEditor.vue')
const BriefingWizardView = () => import('@/views/BriefingWizardView.vue')
const BriefingTemplatesView = () => import('@/views/BriefingTemplatesView.vue')
const BriefingSourcesView = () => import('@/views/BriefingSourcesView.vue')
const BriefingPrint = () => import('@/views/BriefingPrint.vue')
const ArtifactComparePrint = () => import('@/views/ArtifactComparePrint.vue')
const TickerBriefPrint = () => import('@/views/TickerBriefPrint.vue')
const PolicyDeliveryMatrix = () => import('@/views/PolicyDeliveryMatrix.vue')
const SourcePerformanceDashboard = () => import('@/views/SourcePerformanceDashboard.vue')
const RegulatoryIntelligence = () => import('@/views/RegulatoryIntelligence.vue')
const SavedViews = () => import('@/views/SavedViews.vue')
const RegulatoryAlerts = () => import('@/views/RegulatoryAlerts.vue')
const RegulatorySourceManagerChat = () => import('@/components/regulatory/RegulatorySourceManagerChat.vue')
const DataSubscriptions = () => import('@/views/DataSubscriptions.vue')
const FeedbackDashboard = () => import('@/views/FeedbackDashboard.vue')
const StandupReport = () => import('@/views/StandupReport.vue')
const IdeaRoadmap = () => import('@/views/IdeaRoadmap.vue')
// LMS imports
const LearningCatalog = () => import('@/views/LearningCatalog.vue')
const CourseDetail = () => import('@/views/CourseDetail.vue')
const CourseVideoPlayer = () => import('@/views/CourseVideoPlayer.vue')
const MyLearning = () => import('@/views/MyLearning.vue')
const LearningPaths = () => import('@/views/LearningPaths.vue')
const LMSAdmin = () => import('@/views/LMSAdmin.vue')
const CourseCertificate = () => import('@/views/CourseCertificate.vue')
// SCAV Member Verification
const RegisterSCAV = () => import('@/views/RegisterSCAV.vue')
const RegisterGuest = () => import('@/views/RegisterGuest.vue')
const VerifyMember = () => import('@/views/VerifyMember.vue')
// Legal & Compliance Pages
const Subprocessors = () => import('@/views/Subprocessors.vue')
const BAASigningPage = () => import('@/views/BAASigningPage.vue')
const ComingSoon = () => import('@/views/ComingSoon.vue')
// Public Resource Navigator
const ResourceNavigator = () => import('@/views/ResourceNavigator.vue')
const AdvocacyIQView = () => import('@/views/AdvocacyIQView.vue')
const AdvocacyActionView = () => import('@/views/AdvocacyActionView.vue')
const LegislativeWatchPublicView = () => import('@/views/LegislativeWatchPublicView.vue')
const SetupPackView = () => import('@/views/SetupPackView.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/workspace',
    name: 'ProductWorkspace',
    component: () => import('@/views/ProductWorkspace.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/resource-navigator',
    name: 'ResourceNavigator',
    component: ResourceNavigator,
    meta: { requiresAuth: false }
  },
  {
    path: '/action/:token',
    name: 'AdvocacyAction',
    component: AdvocacyActionView,
    meta: { requiresAuth: false }
  },
  {
    path: '/legislative-watch/:token',
    name: 'LegislativeWatchPublic',
    component: LegislativeWatchPublicView,
    meta: { requiresAuth: false }
  },
  {
    path: '/setup-pack/:token',
    name: 'ImplementationSetupPack',
    component: SetupPackView,
    meta: { requiresAuth: false }
  },
  {
    path: '/client-management/:id/onboarding-package',
    name: 'ImplementationPackReview',
    component: SetupPackView,
    meta: { requiresAuth: true, staffPack: true },
  },
  {
    path: '/advocacy-iq',
    name: 'AdvocacyIQ',
    component: AdvocacyIQView,
    meta: { requiresAuth: true }
  },
  {
    path: '/visit',
    name: 'ConferenceVisit',
    beforeEnter(to) {
      const qs = to.fullPath.includes('?') ? to.fullPath.slice(to.fullPath.indexOf('?')) : '';
      window.location.replace('/visit.html' + qs);
    },
    meta: { requiresAuth: false }
  },
  // Legal & Compliance Pages
  {
    path: '/subprocessors',
    name: 'Subprocessors',
    component: Subprocessors,
    meta: { requiresAuth: false }
  },
  // SCAV Member Registration & Verification
  {
    path: '/register-scav',
    name: 'RegisterSCAV',
    component: RegisterSCAV,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'RegisterGuest',
    component: RegisterGuest,
    meta: { requiresAuth: false }
  },
  {
    path: '/verify-member/:token',
    name: 'VerifyMember',
    component: VerifyMember,
    meta: { requiresAuth: false }
  },
  {
    path: '/decision-center',
    name: 'DecisionCenter',
    component: () => import('@/views/DecisionCenterV2.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/decision-center-legacy',
    name: 'DecisionCenterLegacy',
    component: () => import('@/views/DecisionCenter.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/data-suggestions',
    name: 'DataSuggestionsInbox',
    component: () => import('@/views/DataSuggestionsInbox.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ab-testing',
    name: 'ABTestingDashboard',
    component: ABTestingDashboard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/database-connections',
    name: 'DatabaseConnections',
    component: DatabaseConnections,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/duplicate-detection',
    name: 'DuplicateDetection',
    component: DuplicateDetection,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/api-integrations',
    name: 'APIIntegrations',
    component: APIIntegrations,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/regulatory-intelligence',
    name: 'RegulatoryIntelligence',
    component: RegulatoryIntelligence,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/regulatory/source-manager',
    name: 'RegulatorySourceManager',
    component: RegulatorySourceManagerChat,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/regulatory/saved-views',
    name: 'SavedViews',
    component: SavedViews,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/regulatory/alerts',
    name: 'RegulatoryAlerts',
    component: RegulatoryAlerts,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/policy-monitor',
    name: 'DataSourceMonitor',
    component: DataSourceMonitor,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/iq-hub',
    name: 'IQHub',
    component: IQHubView,
    meta: { requiresAuth: true },
  },
  {
    path: '/iq-hub/print',
    name: 'IQHubPrint',
    component: IQHubPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/iq-hub/ticker/print',
    name: 'TickerBriefPrint',
    component: TickerBriefPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/iq-hub/provider-status',
    name: 'ProviderStatus',
    component: ProviderStatusView,
    meta: { requiresAuth: true },
  },
  {
    path: '/iq-hub/provider-status/print',
    name: 'ProviderStatusPrint',
    component: ProviderStatusView,
    meta: { requiresAuth: true },
  },
  {
    path: '/signal-feedback',
    name: 'SignalFeedback',
    component: SignalFeedback,
    meta: { requiresAuth: false },
  },
  {
    path: '/state-iq',
    name: 'StateIQ',
    component: StateIQView,
    meta: { requiresAuth: true },
  },
  {
    path: '/state-iq/print',
    name: 'StateIQPrint',
    component: StateIQPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/policy-alignment',
    redirect: { path: '/advocacy-iq', query: { tab: 'compare' } },
  },
  {
    path: '/artifact-compare/:id/print',
    name: 'ArtifactComparePrint',
    component: ArtifactComparePrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/market-intelligence',
    name: 'MarketIntelligence',
    component: MarketIntelligenceView,
    meta: { requiresAuth: true },
  },
  {
    path: '/docket-iq',
    name: 'DocketIQ',
    component: DocketIQView,
    meta: { requiresAuth: true },
  },
  {
    path: '/what-if-iq',
    name: 'WhatIfIQ',
    component: ScenarioPlannerView,
    meta: { requiresAuth: true },
  },
  {
    path: '/what-if-iq/sessions',
    name: 'WhatIfIQSessions',
    component: ScenarioPlannerListView,
    meta: { requiresAuth: true },
  },
  {
    path: '/what-if-iq/print',
    name: 'WhatIfIQPrint',
    component: ScenarioPlannerPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/policy-engine',
    name: 'PolicyEngine',
    component: PolicyEngine,
    meta: { requiresAuth: true },
  },
  {
    path: '/converging-signals',
    name: 'ConvergingSignals',
    component: ConvergingSignals,
    meta: { requiresAuth: true },
  },
  {
    path: '/converging-signals/print',
    name: 'ConvergingSignalsPrint',
    component: ConvergingSignalsPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/converging-signals-report',
    name: 'ConvergingSignalsReport',
    component: ConvergingSignalsReport,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/converging-signals-report/print',
    name: 'ConvergingSignalsReportPrint',
    component: ConvergingSignalsReportPrint,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/pollie-packets',
    name: 'PolliePackets',
    component: PolliePacketsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/pollie-packets/:id/print',
    name: 'PolliePacketPrint',
    component: PolliePacketPrint,
    meta: { requiresAuth: true },
  },
  {
    path: '/briefings',
    name: 'BriefingWizard',
    component: BriefingWizardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/briefings/templates',
    name: 'BriefingTemplates',
    component: BriefingTemplatesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/briefings/sources',
    name: 'BriefingSources',
    component: BriefingSourcesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/briefings/classic',
    name: 'BriefingEditor',
    component: BriefingEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/policy-delivery-matrix',
    name: 'PolicyDeliveryMatrix',
    component: PolicyDeliveryMatrix,
    meta: { requiresAuth: true },
  },
  {
    path: '/source-performance',
    name: 'SourcePerformanceDashboard',
    component: SourcePerformanceDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/briefings/print',
    name: 'BriefingPrint',
    component: BriefingPrint,
    meta: { requiresAuth: true, printStandalone: true },
  },
  {
    path: '/source-catalog',
    name: 'SourceCatalog',
    component: SourceCatalog,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/data-subscriptions',
    name: 'DataSubscriptions',
    component: DataSubscriptions,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/intake-queue',
    name: 'IntakeQueue',
    component: () => import('@/components/intake/IntakeQueue.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: ClientsList,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/clients/:id',
    name: 'ClientDetail',
    component: ClientDetail,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/clients/:clientId/workflow-settings',
    name: 'ClientWorkflowSettings',
    component: ClientWorkflowSettings,
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/projects/:projectId/settings',
    name: 'ProjectSettings',
    component: ProjectSettings,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/programs',
    name: 'ProgramCatalog',
    component: ProgramCatalog,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true },
  },
  {
    path: '/adi',
    name: 'ADIDashboard',
    component: ADIDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/aiq-ai',
    name: 'AIQDashboard',
    component: AIQDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/aiq/queue',
    name: 'AIQueueView',
    component: () => import('@/views/AIQueueView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/document-iq/start',
    name: 'DocumentIqStart',
    component: () => import('@/views/DocumentIqStartView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/document-iq/oasis-needs/:documentId',
    name: 'OasisNeedsView',
    component: () => import('@/views/OasisNeedsView.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    // Old Remediator URL → Update Policy / Procedure intake
    path: '/document-iq/remediator',
    redirect: { path: '/document-iq/start', query: { mode: 'update' } },
  },
  {
    path: '/document-iq/cases/new',
    name: 'CaseIntakeView',
    component: () => import('@/views/CaseIntakeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/document-iq/cases/:id',
    name: 'CaseReviewView',
    component: () => import('@/views/CaseReviewView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/aiq/clinical-notes',
    name: 'ClinicalNotesUpload',
    component: () => import('@/views/ClinicalNotesUploadView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adi/assessments/:id',
    name: 'ADIWorkbench',
    component: ADIWorkbench,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:id',
    name: 'ComplianceDashboard',
    component: ComplianceDashboard,
    props: route => ({ projectId: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/projects/:id/documents',
    name: 'ProjectDocuments',
    component: ProjectDocuments,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/compliance',
    name: 'ComplianceIntelligence',
    component: ComprehensiveAnalysisDashboard,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/rag-analysis',
    name: 'RAGAnalysis',
    component: RAGAnalysis,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/lab',
    name: 'RequirementLab',
    component: RequirementLab,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/ecp/485-extraction/:documentId',
    name: 'Extract485View',
    component: Extract485View,
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/aiq/insurance-coverage/:documentId',
    name: 'InsuranceCoverageView',
    component: InsuranceCoverageView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/aiq/485/:documentId/review',
    name: 'Client485View',
    component: () => import('@/views/Client485View.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/workflow-from-document',
    name: 'WorkflowFromDocument',
    component: WorkflowFromDocument,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/requests',
    name: 'AnalysisRequestQueue',
    component: AnalysisRequestQueue,
    meta: { requiresAuth: true },
  },
  {
    path: '/analysis/comprehensive',
    name: 'ComprehensiveAnalysis',
    component: ComprehensiveAnalysis,
    meta: { requiresAuth: true },
  },
  {
    path: '/actions',
    name: 'ActionsManager',
    component: ActionsManager,
    meta: { requiresAuth: true },
  },
  {
    path: '/automated-checks',
    name: 'AutomatedChecksManager',
    component: AutomatedChecksManager,
    meta: { requiresAuth: true },
  },
  {
    path: '/check-definition-editor',
    name: 'ComprehensiveCheckDefinitionEditor',
    component: ComprehensiveCheckDefinitionEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/rag-analytics-demo',
    name: 'RAGAnalyticsDemo',
    component: RAGAnalyticsDemo,
    meta: { requiresAuth: true },
  },
  {
    path: '/rag-admin-dashboard',
    name: 'RAGAdminDashboard',
    component: RAGAdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/risk-indicator-library',
    name: 'RiskIndicatorLibrary',
    component: RiskIndicatorLibrary,
    meta: { requiresAuth: true, requiresAdmin: true, requiresPlatformStaff: true },
  },
  {
    path: '/status-changes',
    name: 'StatusChangesReport',
    component: StatusChangesReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/prompt-enhancement',
    name: 'PromptEnhancement',
    component: PromptEnhancement,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/settings/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/onboard',
    name: 'OnboardingWizard',
    component: OnboardingWizard,
    meta: { requiresAuth: true, requiresPlatformStaff: true, clientOrgSetup: true },
  },
  {
    path: '/setup/organization',
    name: 'OrganizationSetupWizard',
    component: OrganizationSetupWizard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/setup/compliance-client',
    name: 'ComplianceOnboardingWizard',
    component: ComplianceOnboardingWizard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/setup/healthcare-client',
    name: 'HealthcareOnboardingWizard',
    component: HealthcareOnboardingWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/patients/intake',
    name: 'PatientIntakeWizard',
    component: PatientIntakeWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/coverage-risk',
    name: 'CoverageRisk',
    component: CoverageRiskDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/plan-coverage',
    name: 'KeepMeCovered',
    component: () => import('@/views/KeepMeCovered.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/plan-coverage-query',
    name: 'PlanCoverageQuery',
    component: PlanCoverageQuery,
    meta: { requiresAuth: true },
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/dis-enrollment-risk',
    name: 'DisEnrollmentRisk',
    component: DisEnrollmentRiskDashboard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/ecp/import',
    name: 'ECPDataImport',
    component: ECPDataImport,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/ecp/eligibility',
    name: 'StediEligibility',
    component: () => import('@/views/StediEligibility.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/kmc-select-report',
    name: 'KmcSelectReport',
    component: () => import('@/views/KmcSelectReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/client-management',
    name: 'ClientManagement',
    component: ClientManagementDashboard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/state-build',
    name: 'StateBuildStates',
    component: () => import('@/views/StateBuildStates.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/library-maintenance',
    name: 'LibraryMaintenance',
    component: () => import('@/views/LibraryMaintenance.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/state-build/:code',
    name: 'StateBuildState',
    component: () => import('@/views/StateBuildState.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/state-build/:code/addresses',
    name: 'StateBuildAddresses',
    component: () => import('@/views/StateWebsiteMaintain.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/client-management/:id/team',
    name: 'OrgTeam',
    redirect: (to) => ({ path: '/onboard', query: { edit: String(to.params.id), step: 'team' } }),
  },
  {
    path: '/client-management/:id',
    name: 'OrgWorkspace',
    component: ClientManagementDashboard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/settings/organization',
    name: 'OrganizationSettings',
    component: OrganizationSettings,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/members',
    name: 'MemberListSettings',
    component: () => import('@/views/MemberListSettings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/baa',
    name: 'BAASigningPage',
    component: BAASigningPage,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/billing',
    name: 'Billing',
    component: BillingSettings,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/settings/billing',
    name: 'BillingSettings',
    component: BillingSettings,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/settings/payments',
    name: 'PaymentSettings',
    component: ConnectOnboarding,
    meta: { requiresAuth: true, requiresAdmin: true, requiresPlatformStaff: true },
  },
  {
    path: '/settings/branding',
    name: 'BrandingManager',
    component: () => import('@/components/BrandingManager.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, requiresPlatformStaff: true },
  },
  {
    path: '/dspy-test',
    name: 'DSPyTestPage',
    component: DSPyTestPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/settings/profile',
    name: 'ProfileSettings',
    component: PollieOrgProfileView,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  // 485 Client Upload Portal (persistent, unauthenticated)
  {
    path: '/upload/485/:token',
    name: 'Upload485Landing',
    component: Upload485Landing,
    props: true,
    meta: { requiresAuth: false },
  },
  // Roster Upload Portal (persistent, unauthenticated)
  {
    path: '/upload/roster/:token',
    name: 'RosterUploadLanding',
    component: RosterUploadLanding,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/upload/eng/:token',
    name: 'EngagementUploadLanding',
    component: EngagementUploadLanding,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/upload/phi/:token',
    name: 'PhiUploadLanding',
    component: EngagementUploadLanding,
    props: (route) => ({ token: route.params.token, mode: 'phi' }),
    meta: { requiresAuth: false },
  },
  // Secure Upload Multi-Step Flow
  {
    path: '/secure-upload/:token',
    name: 'SecureUploadLanding',
    component: SecureUploadLanding,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/analysis',
    name: 'SecureUploadAnalysis',
    component: SecureUploadAnalysis,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/results',
    name: 'SecureUploadResults',
    component: SecureUploadResults,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/feedback',
    name: 'SecureUploadFeedback',
    component: SecureUploadFeedback,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/complete',
    name: 'SecureUploadComplete',
    component: SecureUploadComplete,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/compliance-health',
    name: 'ComplianceHealthDashboard',
    component: ComplianceHealthDashboard,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  // Knowledge Graph Explorer
  {
    path: '/knowledge-graph',
    name: 'KnowledgeGraphExplorer',
    component: () => import('@/components/knowledge-graph/ContextExplorer.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  // Internal Feedback Dashboard (internal users only)
  {
    path: '/internal/feedback',
    name: 'FeedbackDashboard',
    component: FeedbackDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/internal/feedback/queue',
    name: 'IwiQueueManager',
    component: () => import('@/views/IwiQueueManagerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/internal/standup',
    name: 'StandupReport',
    component: StandupReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/internal/demo-studio',
    name: 'DemoStudioLauncher',
    component: () => import('@/views/DemoStudioLauncher.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/internal/product-landing',
    name: 'ProductLandingLauncher',
    component: () => import('@/views/ProductLandingLauncher.vue'),
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/roadmap',
    name: 'IdeaRoadmap',
    component: IdeaRoadmap,
    meta: { requiresAuth: true },
  },
  // LMS Routes
  {
    path: '/learning',
    name: 'LearningCatalog',
    component: LearningCatalog,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/my-courses',
    name: 'MyLearning',
    component: MyLearning,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/paths',
    name: 'LearningPaths',
    component: LearningPaths,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/courses/:id',
    name: 'CourseDetail',
    component: CourseDetail,
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/courses/:courseId/video/:videoId',
    name: 'CourseVideoPlayer',
    component: CourseVideoPlayer,
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/courses/:id/certificate/view',
    name: 'CourseCertificate',
    component: CourseCertificate,
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/courses/:courseId/quiz',
    name: 'CourseQuiz',
    component: () => import('@/views/CourseQuiz.vue'),
    props: true,
    meta: { requiresAuth: true, requiresPlatformStaff: true },
  },
  {
    path: '/learning/admin',
    name: 'LMSAdmin',
    component: LMSAdmin,
    meta: { requiresAuth: true, requiresAdmin: true, requiresPlatformStaff: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // Already-logged-in sessions sitting on the legacy compliance screen
  // (or anyone who navigates there) go to their product home instead.
  if (auth.isAuthenticated() && isForbiddenComplianceLanding(to.path)) {
    next(resolveClientLandingPage(auth));
    return;
  }

  // Conference booth sessions — only KMC, AIQ, and Policy IQ routes.
  // Never block public member pages (legislative watch, action letters, secure upload).
  const isPublicRoute = to.matched.length > 0 && to.matched.every((r) => r.meta.requiresAuth === false);
  if (
    auth.isAuthenticated()
    && isConferenceMode()
    && !isConferenceRoute(to.path)
    && !isPublicRoute
  ) {
    next('/coverage-risk');
    return;
  }

  // If user is authenticated and trying to access home page, redirect by product.
  if (to.path === '/' && auth.isAuthenticated()) {
    if (isConferenceMode()) {
      next('/coverage-risk');
      return;
    }
    next(resolveClientLandingPage(auth));
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      return;
    }

    if (to.matched.some(record => record.meta.requiresAdmin) && !auth.hasPlatformAccess()) {
      next(resolveClientLandingPage(auth));
      return;
    }

    const platformStaffRoles = ['PLATFORM_ADMIN', 'PLATFORM_ENGINEER'];
    if (to.matched.some(record => record.meta.requiresPlatformStaff) && !platformStaffRoles.includes(auth.getUserRole())) {
      const ownOrgId = clientOrgSetupOrgId();
      if (to.meta.clientOrgSetup && ownOrgId && String(to.query.edit || '') === String(ownOrgId)) {
        next();
        return;
      }
      const landing = resolveClientLandingPage(auth);
      const landingIsLocked = router.resolve(landing).matched.some(record => record.meta.requiresPlatformStaff);
      next(landingIsLocked ? '/iq-hub' : landing);
      return;
    }

    next();
    return;
  }

  next();
});

// A deploy renames screen chunks; tabs opened before it get ChunkLoadError on the next click.
// Reload once onto the target route (flag shared with main.js so this cannot loop).
router.onError((error, to) => {
  const isChunkError = error?.name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '');
  if (!isChunkError) return;
  if (sessionStorage.getItem('chunk_reload_attempted')) {
    sessionStorage.removeItem('chunk_reload_attempted');
    return;
  }
  sessionStorage.setItem('chunk_reload_attempted', 'true');
  window.location.assign(to?.fullPath || window.location.href);
});

export default router
